import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ManualCard = ({icon, title, description, file, download}) => {
    return (
        <Card className="manual-card-height">
            <Card.Title className="text-scb font-weight-bold ml-4 mt-4">
                <FontAwesomeIcon icon={icon} size="lg" className="mr-2"/>
                {title}
            </Card.Title>
            <Card.Body className="text-justify">
                {description}
            </Card.Body>
            <Card.Footer className="text-right border-0 bg-white">
                <a href={file} download={download} target="_blank">Select</a>
            </Card.Footer>
        </Card>
    );
}

export default ManualCard